const updateEquipmentsStr = {
  toastr: 'Equipamento atualizado',
  toastrError: 'Equipamento já cadastrado',
  toastrError2: 'Erro ao editar Equipamento',
  serialNumberError: 'Já existe um equipamento com este mesmo número de série para este site',
};

export default updateEquipmentsStr;
